import React from "react";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { PANEL_BUTTON_SX, PANEL_TEXT_MUTED } from "@/theme/panelStyles.js";
import { WW_BLUE } from "@/theme/tokens.js";

const COMPACT_SX = {
  justifyContent: "flex-start",
  textTransform: "none",
  fontSize: "12px",
  fontWeight: 600,
  color: WW_BLUE,
  border: "1px dashed #cfd8df",
  borderRadius: "8px",
  py: "4px",
  px: "10px",
  "& .MuiButton-startIcon > *:nth-of-type(1)": { fontSize: 15 },
  "&:hover": { bgcolor: "rgba(0,79,125,0.04)", borderColor: WW_BLUE },
};

export default function NewVoyageCard({ size = "full", onPlan }) {
  if (size === "compact") {
    return (
      <Box sx={{ mx: 1, mt: 0.5 }}>
        <Button size="small" fullWidth startIcon={<AddIcon />} onClick={onPlan} sx={COMPACT_SX}>
          Plan new voyage
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mx: 1,
        my: 0.5,
        p: 1.5,
        bgcolor: "#f7f9fb",
        border: "1px solid #e2e8ee",
        borderRadius: "8px",
      }}
    >
      <Typography sx={{ fontSize: "13px", fontWeight: 700, color: WW_BLUE }}>
        No active voyage yet
      </Typography>
      <Typography sx={{ mt: 0.25, fontSize: "12px", color: PANEL_TEXT_MUTED }}>
        Plan a route to start a new voyage.
      </Typography>
      <Button
        size="small"
        variant="contained"
        startIcon={<AddIcon sx={{ fontSize: 16 }} />}
        onClick={onPlan}
        sx={{ ...PANEL_BUTTON_SX, mt: 1.25 }}
      >
        Plan voyage
      </Button>
    </Box>
  );
}
